import eyeIcon from './../Assets/icons/eye 1.svg';
import editIcon from './../Assets/icons/Un-Checkbox.svg';

export const TERMSET_TABLE_HEADERS = [
  // "Sr No.",
  // "Business Partner Name",
  "Termset Name",
  "Description",
  "Status",
  "Action"
];

export const TERMSET_TABLE_DATA = [
  { id: 1, termsetName: "Termset 1", description: "Description 1", status: "Active", actions: "Edit/Delete" },
  { id: 2, termsetName: "Termset 2", description: "Description 2", status: "Inactive", actions: "Edit/Delete" },
  // Add more entries as needed
];

export const TERMSET_KEY_MAPPING = {
  // "Sr No.": "Sr No.",
  // "Business Partner Name": "businessPartnerName",
  "Termset Name": "term_name",
  "Description": "term_desc",
  "Status": "status",
  "Action": [
    { type: "edit", icon: editIcon, label: "Edit" },
    // { type: "view", icon: eyeIcon, label: "View" }
  ]
};
